import { E_XYGT_TagName } from "@/custom/sensor"
import { E_AlarmLevel, E_AlarmStatus, E_AlarmType, E_DeviceStatus } from "../enums"
import { ICoordinate, IPageData, IPageParams } from "../types"
import { IFileListItem } from "./file.types"
import { E_OnlineOffline } from "./overview.types"
import { E_SensorKlass, ISensorSetItem } from "./sensor.types"
import { E_FaultType } from "./fault.types"
import { E_ProtocolVersion } from "./sensorNew.types"

export enum E_ShowStatus {
    Yes = 1
}

export interface IOnlineDetectionHomeParams {
    companyId?: number
    areaId?: number
    filter?: E_AlarmLevel |  /*重点关注*/ 4
}

export interface IStatus {
    offAlarm: number
    normal: number
    dAlarm: number
    cAlarm: number
    // 倾角
    qalarm: number
    // 低电压  
    balarm: number
}

export interface IEquipmentFaultVO {
    faultReason: string
    createTime: string
    faultType: E_FaultType
}

export interface ISensorAlarmLevel {
    normal: number
    offAlarm: number
    dAlarm: number
    cAlarm: number
}

export interface IEquipmentItem extends ICoordinate {
    /**
     * 设备名称
     */
    equipmentName: string
    alarmStatus: E_AlarmStatus
    alarmLevel: E_AlarmLevel
    equipmentId: number
    /**
     * 是否收藏
     */
    equipmentCollect: boolean

    /**
     * 模型图片
     */
    equipmentImg: string

    /**
     * 只有true才展示诊断分析
     */
    isDiagnosis: boolean

    /**
     * 故障诊断
     */
    equipmentFaultVOS: IEquipmentFaultVO[]

    /**
     * 数量
     */
    sensorAlarmLevel: ISensorAlarmLevel

    /**
     * 诊断次数
     */
    diagnosesCount: number

    /**
     * 上传图片
     */
    imgId?: number
    imgUrl?: string

    /**
     * 报警条数
     */
    alarmCount: number
    /**
     * 得分
     */
    healthScore: number

    companyId: number
    areaId: number

    /**
     * 故障诊断按钮显示状态
     */
    diagnosesNumShowStatus?: E_ShowStatus
    /**
     * 声纹按钮显示状态     
     */
    voicePrintNumShowStatus?: E_ShowStatus
    /**
     * 报警按钮显示状态
     */
    alarmNumShowStatus?: E_ShowStatus
    /**
     * 波形显示状态
     */
    waveShowStatus?: E_ShowStatus
    /**
     * 排序
     */
    orderNum?: number

    /**
     * 低电压
     */
    batteryShowStatus?: E_ShowStatus

    alarmBatteryCount?: number

    /**
     * 终端位移
     */
    angleShowStatus?: E_ShowStatus

    alarmAngleCount?: number

    /**
     * 粉尘展示
     */
    dustShowStatus?: E_ShowStatus

    /**
     * 粉尘近1天报警条数
     */
    dustShowCount?: number

    /**
     * 气体展示
     */
    gasShowStatus?: E_ShowStatus

    /**
     * 气体 近1天报警条数
     */
    gasShowCount?: number
}

export interface IOnlineDetectionHomeData extends ICoordinate {
    /**
     * 故障诊断数量
     */
    diagnosesCount: number
    sensor: IStatus
    equipment: IStatus
    equipmentList: IEquipmentItem[]
}

export interface IOnlineDetectionEquipmentParams {
    companyId?: number
    areaId?: number
    equipmentId: number
    filter?: E_AlarmLevel
}

export interface IPointMapping extends ICoordinate {
    /**
     * 报警等级
     */
    alarmLevel: E_AlarmLevel
    createTime: string
    mappingId: number
    mappingName: string
    /**
     * 传感器id
     */
    sensorId?: string
    /**
     * 温度
     */
    temp: string
    /**
     * 振动烈度
     */
    vibrate: string

    /**
     * 图片展示
     */
    defaultFile?: IFileListItem

    fileList?: IFileListItem[]

    /**
     * 传感器类型
     */
    sensorType: E_SensorKlass
    signalHeart: number

    /**
     * 报警按钮显示状态
     */
    alarmNumShowStatus?: E_ShowStatus
    /**
     * 声纹按钮显示状态
     */
    voicePrintNumShowStatus?: E_ShowStatus
    /**
     * 电压报警
     */
    batteryShowStatus?: E_ShowStatus
    /**
     * 倾角
     */
    angleShowStatus?: E_ShowStatus

    temCMax?: number
    temDMax?: number

    vXCMax?: number
    vXDMax?: number
    vYCMax?: number
    vYDMax?: number
    vZCMax?: number
    vZDMax?: number

    vibrateX: number
    vibrateY: number
    vibrateZ: number

    /**
     * 粉尘展示
     */
    dustShowStatus?: E_ShowStatus

    dust?: number

    dustAlarm?: number
    dustPreAlarm?: number

    /**
     * 气体展示
     */
    gasShowStatus?: E_ShowStatus

    gasEX?: number

    exAlarm?: number
    exPreAlarm?: number

    gasH2S?: number
    h2sAlarm?: number
    h2sPreAlarm?: number
}

export interface IHistoryChartItem {
    day: string
    dayData: {
        cAlarmCount: number
        dAlarmCount: number
    }
}

export interface IOnlineDetectionEquipmentData {
    companyId: number
    areaId: number
    equipmentId: number
    equipmentName: string
    imgUrl: string
    equipmentImg: string
    /**
     * 7天报警数据查询
     */
    dayDataList: IHistoryChartItem[]
    sensor: IStatus
    sensorList: IPointMapping[]
}

export interface IMappingData extends ICoordinate {
    alarmCollect: number;
    alarmLevel: number;
    alarmThresholdId: number;
    alarmTypeList: string;
    areaId: number;
    collectMode: number;
    collectorID: null;
    /**
     * 采集间隔
     */
    collectSpace: number;
    collectTime: number;
    collectWork: null;
    companyId: number;
    createTime: string;
    delFlag: number;
    devID: string;
    equipmentId: number;
    expand: null;
    fileIds: null;
    /**
     * 网关ID
     */
    gatewayId: number;
    /**
     * 传感器编号
     */
    id: string
    isFault: number
    isReadParam1: number
    isReadParam2: number
    isReadParam3: number
    isReadParam4: number
    lastCollectTime: number
    lastTime: string
    location: null
    mac: string
    mappingId: number
    mappingName: string
    mhfHz: string
    mhfFlag: number
    name: string
    sensorSet: ISensorSetItem[]
    sleepT: number
    dataUpload: number
    sort: null
    type: E_SensorKlass
    updateTime: null
    x1: null
    y1: null
    z1: null
    tagName: string

    companyName: string
    areaName: string
    equipmentName: string


    protocolVer: E_ProtocolVersion

}
export interface ISensorData {
    ax: number;
    ay: number;
    /**
     * 加速度峰值
     */
    az: number;
    battery: number;
    /**
     * 波峰因素
     */
    bfX: null;
    bfY: null;
    bfZ: null;
    createTime: string;
    /**
     * 包络
     */
    envelopeX: null;
    /**
     * 包络
     */
    envelopeY: null;
    /**
     * 包络
     */
    envelopeZ: null;
    /**
     * 电流表值
     */
    expand?: string;
    f: number;
    fx: number;
    fy: number;
    fz: number;
    id: number;
    latitude: null;
    longitude: null;
    mappingId: number;
    mediumErrorHz: number
    pyX: null;
    pyY: null;
    pyZ: null;
    /**
     * 峭度
     */
    qx: null;
    qy: null;
    qz: null;
    /**
     * 转速
     */
    rotateSpeed: null;
    /**
     * 轴位移
     */
    axisDis: number
    rssi: null;
    rx: number;
    ry: number;
    rz: number;
    sensorId: string;
    sleepT: number;
    sx: number;
    sy: number;
    /**
     * 位移峰峰值
     */
    sz: number;
    /**
     * 温度
     */
    tem: number;
    tem2: null;
    temperature: null;
    ux: null;
    uy: null;
    uz: null;
    vx: number;
    /**
     * 速度RMS
     */
    vy: number;
    vz: number;
    yx: null;
    yy: null;
    yz: null;


    /**
     * 可燃
     */
    gasEX: number
    /**
     * 硫化氢
     */
    gasH2S: number
    /**
     * 一氧化碳
     */
    gasCO: number
    /**
     * 氨气
     */
    gasNH3: number
    /**
     * 二氧化硫
     */
    gasSO2: number
    /**
     * 粉尘
     */
    dust: number


    /**
     * 软件版本号
     */
    sware: string
    /**
     * 硬件版本号 
     */
    hware: string
}

export interface IOnlineDetectionMappingData {
    fileIds: number[]
    fileArray: IFileListItem[]

    mapping: IMappingData
    /**
     * 特征值
     */
    sensorData: ISensorData
}


export interface IOnlineDetectionMappingListParams {
    companyId: number
    areaId: number
    equipmentId: number
}

export interface IOnlineDetectionMappingListItem extends IPointMapping, ICoordinate {

}

export type IOnlineDetectionMappingListData = IOnlineDetectionMappingListItem[]

/**
 * $t('enum.E_OrderByColumn.alarm')
 * $t('enum.E_OrderByColumn.custom')
 * $t('enum.E_OrderByColumn.collect')
 */
export enum E_OrderByColumn {
    alarm = 'alarm',
    custom = 'custom',
    collect = 'collect'
}


export type IOnlineDetectionEquipmentCurrentStatusParams = Partial<{
    /**
     * 设备状态
     */
    alarmStatus: E_AlarmStatus
    areaId: number
    companyId: number
    equipmentName: string
    orderByColumn: E_OrderByColumn
}>

export interface IOnlineDetectionEquipmentCurrentStatusData {
    cAlarm: number
    dAlarm: number
    normal: number
    offAlarm: number
}


export type IOnlineDetectionEquipmentMonitorParams = IPageParams & Partial<{
    /**
     * 设备状态
     */
    alarmStatus: E_AlarmStatus
    areaId: number
    companyId: number
    equipmentName: string
    orderByColumn: E_OrderByColumn
}>


export type IOnlineDetectionEquipmentMonitorData = IPageData<IEquipmentItem>

export interface IOnlineDetectionMappingCurrentStatusParams {
    /**
    * 设备状态
    */
    alarmStatus: E_AlarmStatus
    areaId: number
    companyId: number
    equipmentName: string
    orderByColumn: E_OrderByColumn
}
export interface IOnlineDetectionMappingCurrentStatusData {
    balarm: number
    cAlarm: number
    dAlarm: number
    normal: number
    offAlarm: number
    qalarm: number
}

